import { createApp } from 'vue'
import { createPinia } from 'pinia'
import VueCookies from 'vue-cookies'

import App from '@/App.vue'
import router from '@/router'

import CoreuiVue from '@coreui/vue-pro'
import CIcon from '@coreui/icons-vue'
import { icons } from '@/icons'

import 'sweetalert2/dist/sweetalert2.min.css'

const app = createApp(App)
app.use(createPinia())
app.use(router)
app.use(CoreuiVue)
app.use(VueCookies)

app.provide('icons', icons)
app.component('CIcon', CIcon)

app.mount('#app')
